import HeroSection from "./HeroSection";
import FeaturesSection from "./FeaturesSection";
import StatsStrip from "./StatsStrip";
import WorkflowStrip from "./WorkflowStrip";
import Testimonials from "./Testimonials";
import CTASection from "./CTASection";
import FooterSection from "./FooterSection";
import Navbar from "./Navbar";
import ModuleOverviewSection from "../components/ModuleOverviewSection";
import SystemStandardsStrip from "../components/SystemStandardsStrip";
import FAQSection from "../components/FAQSection";
import IntegrationsAndRoadmapSection from "../components/IntegrationsAndRoadmapSection";




export default function LandingPage() {
  return (
    <>
      <Navbar />
      <HeroSection />
      <ModuleOverviewSection />
      {/* <FeaturesSection /> */}
      <CTASection/>
      <StatsStrip />  
       <WorkflowStrip /> 
     
       <IntegrationsAndRoadmapSection />
       <FAQSection /> 
         <Testimonials/>
       <SystemStandardsStrip /> 
       <FooterSection/>
    </>
  );
}
